import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import ReactCountryFlag from "react-country-flag";
import { ArrowRight, ChevronRight, FileText, Receipt, ScrollText, Smartphone } from "lucide-react";
import "../account.css";
import "./accountAboutPage.css";

const APP_VERSION = "1.1.0";
const BUILD_NUMBER = "1";

const AboutPage = () => {
    const { language } = useContext(CombinedContext);
    const menu = translations[language].account.menu;
    const about = translations[language].account.aboutSinFila;
    const t = translations[language].account.about || {};

    const legal = [
        { id: "terms", label: menu.terms, icon: ScrollText, path: "/account/terms" },
        { id: "privacy", label: menu.privacy, icon: FileText, path: "/account/privacy" },
        { id: "refund", label: menu.refund, icon: Receipt, path: "/account/refund" },
    ];

    return (
        <div className="ac-page apa">
            {/* ── STORY ── */}
            <section className="ac-hero apa-hero">
                <span className="apa-flag-pill">
                    <ReactCountryFlag
                        countryCode="DO"
                        svg
                        style={{ width: "1.15em", height: "1.15em" }}
                        aria-label="Dominican Republic"
                    />
                    {about.flag}
                </span>

                <h1 className="ac-hero-title">{about.title}</h1>
                <p className="apa-tagline">{about.tagline}</p>

                <p className="ac-hero-sub">{about.intro}</p>
                <p className="ac-hero-sub apa-vision">{about.vision}</p>

                <Link to="/about" className="apa-learnmore">
                    {about.learnMore}
                    <ArrowRight size={15} />
                </Link>
            </section>

            {/* ── APP VERSION ── */}
            <section className="ac-card">
                <div className="ac-list">
                    <div className="ac-row is-muted">
                        <span className="ac-icon">
                            <Smartphone size={16} />
                        </span>
                        <span className="ac-row-copy">
                            <span className="ac-row-label">{t.appName || "Sin Fila"}</span>
                            <span className="ac-row-hint">{t.version || "Version"}</span>
                        </span>
                        <span className="ac-row-value">
                            v{APP_VERSION} ({BUILD_NUMBER})
                        </span>
                    </div>
                </div>
            </section>

            {/* ── LEGAL ── */}
            <div className="apa-group">
                <p className="ac-label apa-group-label">{t.legal || "Legal"}</p>

                <section className="ac-card">
                    <div className="ac-list">
                        {legal.map((item) => {
                            const Icon = item.icon;
                            return (
                                <Link key={item.id} to={item.path} className="ac-row">
                                    <span className="ac-icon">
                                        <Icon size={16} />
                                    </span>
                                    <span className="ac-row-copy">
                                        <span className="ac-row-label">{item.label}</span>
                                    </span>
                                    <ChevronRight size={17} className="ac-row-chevron" />
                                </Link>
                            );
                        })}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AboutPage;
